export class DatapointModel {

  public id?: number;
  public device?: number;
  public deviceName?: string;
  public measure?: number;
  public measureName?: string;
  public unit?: string;
  public period?: number;
  public modified?: string;
  public modifiedBy?: string;

  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.device = data.device;
      this.deviceName = data.deviceName;
      this.measure = data.measure;
      this.measureName = data.measureName;
      this.unit = data.unit;
      this.period = data.period;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
    }
  }

  public isValid() {
    return !!this.device && !!this.measure && !!this.period;
  }
}
